<template>
  <div>
    <form id="formSiteSetupUserLevels" @change="clearErrors()" class="d-flex flex-column" v-on:submit.prevent="updateUserLevelsSettings">
      <div class="d-flex flex-column tab-card-form">
        <div class="element-info">
          <div class="row align-items-center">
            <div v-if="this.mobile" class="col-sm-8">
              <div class="element-info-with-icon justify-content-center">
                <div class="element-info-text text-center">
                  <h5 class="element-inner-header">User levels</h5>
                  <div class="element-inner-desc">Here you can select which user levels should be made available to this client.</div>
                </div>
              </div>
            </div>
            <div v-else class="col-sm-8">
              <div class="element-info-with-icon">
                <div class="element-info-icon">
                  <fontAwesomeIcon :icon="['fas', 'users-cog']" size="2x" />
                </div>
                <div class="element-info-text ml-5">
                  <h5 class="element-inner-header">User levels</h5>
                  <div class="element-inner-desc">Here you can select which user levels should be made available to this client.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-box d-flex flex-column">
          <div class="row">
            <b-form-group class="mt-3 col-lg-4 col-sm-12">
              <div v-if="this.mobile" slot="description">
                <p>Allows document viewing</p>
              </div>
              <b-input-group id="staff">
                <b-form-checkbox
                  v-model="setupUserLevels.staff"
                  name="staff"
                  :value="1"
                  :unchecked-value="0">
                  Staff
                </b-form-checkbox>
              </b-input-group>
              <b-popover v-if="!this.mobile" target="staff" triggers="hover" title="Tip" placement="left">
                <div class="text-size-small">
                  <p><b class="text-uppercase">Staff</b> <br>Allows document viewing</p>
                </div>
              </b-popover>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-4 col-sm-12">
              <div v-if="this.mobile" slot="description">
                <p>Allows document viewing and copy sending</p>
              </div>
              <b-input-group id="credit_controller">
                <b-form-checkbox
                  v-model="setupUserLevels.credit_controller"
                  name="credit_controller"
                  :value="1"
                  :unchecked-value="0">
                  Credit Controller
                </b-form-checkbox>
              </b-input-group>
              <b-popover v-if="!this.mobile" target="credit_controller" triggers="hover" title="Tip" placement="left">
                <div class="text-size-small">
                  <p><b class="text-uppercase">Credit Controller</b> <br>Allows document viewing and copy sending</p>
                </div>
              </b-popover>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-4 col-sm-12">
              <div v-if="this.mobile" slot="description">
                <p>Allows document viewing, copy sending and management of customers & users</p>
              </div>
              <b-input-group id="credit_manager">
                <b-form-checkbox
                  v-model="setupUserLevels.credit_manager"
                  name="credit_manager"
                  :value="1"
                  :unchecked-value="0">
                  Credit manager
                </b-form-checkbox>
              </b-input-group>
              <b-popover v-if="!this.mobile" target="credit_manager" triggers="hover" title="Tip" placement="left">
                <div class="text-size-small">
                  <p><b class="text-uppercase">Credit manager</b> <br>Allows document viewing, copy sending and management of customers & users</p>
                </div>
              </b-popover>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-4 col-sm-12">
              <div v-if="this.mobile" slot="description">
                <p>Allows CRM access, document viewing, copy sending and management of customers, users & batches</p>
              </div>
              <b-input-group id="caller">
                <b-form-checkbox
                  v-model="setupUserLevels.caller"
                  name="caller"
                  :value="1"
                  :unchecked-value="0">
                  Caller
                </b-form-checkbox>
              </b-input-group>
              <b-popover v-if="!this.mobile" target="caller" triggers="hover" title="Tip" placement="left">
                <div class="text-size-small">
                  <p><b class="text-uppercase">Caller</b> <br>Allows CRM access, document viewing, copy sending and management of customers, users & batches</p>
                </div>
              </b-popover>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-4 col-sm-12">
              <div v-if="this.mobile" slot="description">
                <p>Allows document viewing, copy sending and management of customers, users & batches</p>
              </div>
              <b-input-group id="admin">
                <b-form-checkbox
                  v-model="setupUserLevels.admin"
                  name="admin"
                  :value="1"
                  :unchecked-value="0">
                  Admin
                </b-form-checkbox>
              </b-input-group>
              <b-popover v-if="!this.mobile" target="admin" triggers="hover" title="Tip" placement="left">
                <div class="text-size-small">
                  <p><b class="text-uppercase">Admin</b> <br>Allows document viewing, copy sending and management of customers, users & batches</p>
                </div>
              </b-popover>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-4 col-sm-12">
              <div v-if="this.mobile" slot="description">
                <p>Adds Site set-up to the Admin level</p>
              </div>
              <b-input-group id="super_admin">
                <b-form-checkbox
                  v-model="setupUserLevels.super_admin"
                  name="super_admin"
                  :value="1"
                  :unchecked-value="0">
                  Super-admin
                </b-form-checkbox>
              </b-input-group>
              <b-popover v-if="!this.mobile" target="super_admin" triggers="hover" title="Tip" placement="left">
                <div class="text-size-small">
                  <p><b class="text-uppercase">Super-admin</b> <br>Adds Site set-up to the Admin level</p>
                </div>
              </b-popover>
            </b-form-group>
          </div>
          <transition name="fade">
            <ResponseInfo v-if="getResponseInfo.name == 'siteSetupUserLevels'" class="mt-3"/>
          </transition>
          <button v-if="!this.mobile" class="btn btn-primary mt-3 align-self-end" type="submit" value="submit">Update</button>
          <button v-else class="btn btn-secondary mt-3 align-self-end" type="submit" value="submit">Update</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default{
  name: 'SiteSetupUserLevels',
  components: {
    ResponseInfo
  },
  data() {
    return {
      setupUserLevels: {},
      mobile: window.innerWidth <= 700
    }
  },
  created() {
    userLevelsSettings:{
        this.$store.dispatch('getUserLevelsSettings')
        .then(() => {
            if(Object.keys(this.userLevelsSettings).length){
                this.setupUserLevels = Object.assign({}, this.userLevelsSettings)
            }
        })
    }
    window.addEventListener('resize', () => {
          this.mobile = window.innerWidth <= 700
    })
  },
  computed:{
      ...mapGetters(['allTemplateDetails', 'getUserDetails','getIsNewsnet', 'getUserLevelsSettings', 'getResponseInfo']),
      userLevelsSettings:{
          get() {
              return this.$store.getters.getUserLevelsSettings
          }
      }
  },
  methods: {
    clearErrors() {
      //clearing the error message when we change the input
      this.$store.commit('setValidationErrors', [])
    },
    updateUserLevelsSettings(){
      this.$store.dispatch('setUserLevelsSettings',{
          data: this.setupUserLevels
      })
    }
  }
}
</script>

<style lang="css" scoped>
.tab-card-form{
  min-width: 70%;
}
.text-size-small{
  font-size: 0.8rem;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
